import { ReactNode } from 'react';

import { Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

import { betslipModalStyles } from './shared-modal-styles';

export const BetSlipModalStickyHeaderRow = ({ children }: { children: ReactNode }) => (
    <Row
        py="s16"
        height={52}
        justifyContent="space-between"
        style={betslipModalStyles.sectionHeader}
        borderBottomColor={ds.colorToken.border.strong}
        borderBottomWidth={1}
    >
        {children}
    </Row>
);
